<template>
    <div class="alert alert-danger">
        This is a page for logged in users
        {{userInfo}}
      <router-link to="/">
        <br >Home
      </router-link>

    </div>


</template>

<script>
    import UserInfoStore from '../app/user-info-store';
    export default {
        name: 'HelloWorld',
        data: function () {
            return {
                userInfo: UserInfoStore.state.cognitoInfo
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
